import React, { useEffect, useState } from 'react';

import 'features/accounts/components/accounts-list/accounts-list.scss';
import DetailsContainer from 'containers/details-container/details-container';
import { useModal } from '@ampol/design-system';
import AccountDetailModal from 'features/accounts/modals/account-detail-modal/account-detail-modal';
import { useDispatch, useSelector } from 'react-redux';
import { setAccountDefaultButton } from 'actions/modalMetaActions';
import PageHeader from 'components/layout/page-header/page-header';
import { trackCustomEvent } from 'utilities/app-insights';

/**
 * List of accounts
 */
const AccountsList = () => {
  const dispatch = useDispatch();

  const [selectedAccount, setSelectedAccount] = useState(null);

  const primaryActionButton = useSelector((state) => state.modalStore.primaryActionButton);
  const secondaryActionButton = useSelector((state) => state.modalStore.secondaryActionButton);
  const loggedInUser = useSelector((state) => state.userStore.loggedInUser);
  const assignedAccountNumber = useSelector((state) => state.userStore.assignedAccountNumber);

  useEffect(() => {
    if (selectedAccount) {
      dispatch(setAccountDefaultButton());
      detailModal.open();
    }
  }, [selectedAccount]);

  const handleClose = () => {
    detailModal.close();
  };

  const getModalActions = () => [
    ...(primaryActionButton ? [primaryActionButton] : []),
    ...(secondaryActionButton
      ? [{ ...secondaryActionButton, onClick: secondaryActionButton.onClick || handleClose }]
      : []),
  ];

  const detailModal = useModal({
    id: 'account-details',
    title: `${selectedAccount?.contractName}`,
    subtitle: `Account - ${selectedAccount?.contractNumber}`,
    content: <AccountDetailModal account={selectedAccount} onClose={handleClose} />,
    variant: 'triple',
    color: 'blue',
    actions: getModalActions(),
    onClose: () => {
      trackCustomEvent('Close Account Modal', loggedInUser, assignedAccountNumber, 'Closed Account Detail modal.', {
        selectedAccount,
      });
      setSelectedAccount(null);
    },
    formId: primaryActionButton?.formId,
  });

  const handleItemSelected = (item) => {
    trackCustomEvent(
      'Open Account Modal',
      loggedInUser,
      assignedAccountNumber,
      'Clicked on Account to view account details.',
      { selectedAccount: item?.contractNumber }
    );
    setSelectedAccount(item);
  };

  return (
    <div className={'accounts-list'}>
      <PageHeader title='Accounts' />
      <DetailsContainer onItemSelected={handleItemSelected} />
    </div>
  );
};

export default AccountsList;
